<div class="flex flex-col h-screen bg-white overflow-hidden">
    <!-- Header -->
    <header class="flex-none p-6 z-20 bg-white relative">
        <a routerLink="/login" class="inline-block">
            <img src="assets/FINTRAX_LOGO_POS.svg" alt="Fintrax" class="h-10" />
        </a>
    </header>

    <!-- Main Content -->
    <main class="flex-grow flex items-center justify-center p-6 bg-slate-50/50 overflow-y-auto">
        <div class="w-full max-w-lg bg-white p-8 rounded-2xl shadow-sm border border-slate-100 flex flex-col my-auto">
            
            <h1 class="text-2xl font-bold text-slate-800 mb-6 text-center" i18n="@@resetPasswordConfirm.choosePassword">Kies een nieuw wachtwoord</h1>

            <form [formGroup]="resetConfirmForm" (ngSubmit)="onSubmit()" class="flex flex-col w-full gap-5">
                
                <div class="flex flex-col gap-2">
                    <label for="emailInput" class="text-sm font-medium text-slate-700" i18n="@@email">E-mailadres</label>
                    <input 
                        id="emailInput" 
                        type="email" 
                        formControlName="email" 
                        class="w-full px-4 py-2 rounded-lg border border-slate-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none transition-all" 
                    />
                </div>

                <div class="flex flex-col gap-2">
                    <label for="inputPassword1" class="text-sm font-medium text-slate-700" i18n="@@register.password">Wachtwoord*</label>
                    <app-password-toggle>
                        <input 
                            id="inputPassword1" 
                            type="password" 
                            formControlName="newPassword1" 
                            class="w-full px-4 py-2 rounded-lg border border-slate-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none transition-all" 
                            required 
                        />
                    </app-password-toggle>
                    @if (resetConfirmForm.controls.newPassword1.touched && resetConfirmForm.controls.newPassword1.errors?.required) {
                        <div class="text-sm text-red-600" i18n="@@error.required">Dit veld is verplicht.</div>
                    }
                    @if (resetConfirmForm.controls.newPassword1.touched && resetConfirmForm.controls.newPassword1.errors?.minlength) {
                        <div class="text-sm text-red-600" i18n="@@register.error.minlength">Het wachtwoord moet minstens {{ minPasswordLength }} tekens lang zijn</div>
                    }
                    @if (resetConfirmForm.controls.newPassword1.touched && resetConfirmForm.controls.newPassword1.errors?.passwordStrength?.hasUpperCase === false) {
                        <div class="text-sm text-red-600" i18n="@@register.error.hasUpperCase">Het wachtwoord moet hoofdletters bevatten</div>
                    }
                    @if (resetConfirmForm.controls.newPassword1.touched && resetConfirmForm.controls.newPassword1.errors?.passwordStrength?.hasLowerCase === false) {
                        <div class="text-sm text-red-600" i18n="@@register.error.hasLowerCase">Het wachtwoord moet kleine letters bevatten</div>
                    }
                    @if (resetConfirmForm.controls.newPassword1.touched && resetConfirmForm.controls.newPassword1.errors?.passwordStrength?.hasNumeric === false) {
                        <div class="text-sm text-red-600" i18n="@@register.error.hasNumeric">Het wachtwoord moet cijfers bevatten</div>
                    }
                    @if (resetConfirmForm.controls.newPassword1.touched && resetConfirmForm.controls.newPassword1.errors?.passwordStrength?.hasSpecial === false) {
                        <div class="text-sm text-red-600" i18n="@@register.error.hasSpecial">Het wachtwoord moet bijzondere tekens bevatten ({{ specialCharacters | join: ', ' }})</div>
                    }
                </div>

                <div class="flex flex-col gap-2">
                    <label for="inputPassword2" class="text-sm font-medium text-slate-700" i18n="@@form.passwordVerification">Wachtwoord opnieuw invoeren*</label>
                    <app-password-toggle>
                        <input 
                            id="inputPassword2" 
                            type="password" 
                            formControlName="newPassword2" 
                            class="w-full px-4 py-2 rounded-lg border border-slate-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100 outline-none transition-all" 
                            required 
                        />
                    </app-password-toggle>
                    @if (resetConfirmForm.controls.newPassword2.touched && resetConfirmForm.errors?.notEqual) {
                        <div class="text-sm text-red-600" i18n="@@register.error.passwordVerification">Wachtwoorden komen niet overeen.</div>
                    }
                    @if (resetConfirmForm.controls.newPassword2.touched && resetConfirmForm.controls.newPassword2.errors?.required) {
                        <div class="text-sm text-red-600" i18n="@@error.required">Dit veld is verplicht.</div>
                    }
                </div>

                @if (success) {
                    <div class="p-4 bg-green-50 text-green-700 rounded-lg text-sm text-center" i18n="@@resetPasswordConfirm.resetConfirmMessage">
                        Nieuw wachtwoord werd ingesteld.
                    </div>
                }

                <button 
                    type="submit" 
                    class="button-primary w-full py-3 mt-2 rounded-lg font-medium shadow-sm hover:shadow-md transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                    [disabled]="!resetConfirmForm.valid || busy"
                >
                    @if (!busy) {
                        <span i18n="@@resetPasswordConfirm.setNewPassword">Nieuw wachtwoord instellen</span>
                    } @else {
                        <fa-icon [icon]="loadingIcon" [animation]="'spin'"></fa-icon>
                    }
                </button>

                <div class="mt-4 flex justify-center">
                    <a routerLink="/login" class="font-bold text-blue-600 hover:text-blue-700 hover:underline text-sm" i18n="@@public.backToLogin">Terug naar loginpagina</a>
                </div>

            </form>
        </div>
    </main>
</div>
